import React from "react";
import "./Policies.css";

export default function Policies() {
  return (
    <div class="policies">
      <div class="policy">
        <h2>Ticket Purchase Policy</h2>
        <p>
          Our policy facilitates convenient ticket purchases online. Presently,
          we accept cash and e-transfers as payment methods, with the
          possibility of future changes. Upon purchasing a seat, your ride for
          the specified day is confirmed. The assigned driver will contact you
          to provide time updates. In the event of any alterations to the
          scheduled time or mechanical concerns with the vehicle, you will
          receive timely updates well in advance of the scheduled time.
        </p>
      </div>

      <div class="policy">
        <h2>Refund Policy</h2>
        <p>
          Our refund policy adheres to strict guidelines for fairness and
          transparency. We understand the importance of providing clear terms
          and conditions to our customers, outlining the circumstances under
          which refunds may be issued. Additionally, our dedicated customer
          service team is available to assist with any inquiries or concerns
          regarding refund requests, striving to address them promptly and
          professionally.
        </p>
        <p>
          Traffic can be the main villain most of the times which delay the time
          of arrival and sometimes mechanical errors do happen: If the van is
          late:
        </p>
        <ul>
          <li>
            Under 2 hours the passengers won’t be qualified for any refund.
          </li>
          <li>
            For more than 2 hours, we update the time at the very first moment,
            the passenger can decide to take the ride or cancel the ride. If the
            passenger still needs the trip we offer a 50% discount on the fare
            for the next trip for all our loyal customers and If the passenger
            no longer needs the ride, the refund will be initiated immediately.
          </li>
        </ul>
        <p>
          Cancellations can be made free of cost before 12 hours of the trip and
          after that only 50% of the amount will be refunded.
        </p>
        <p>
          We can wait for passengers for up to 10 minutes; however, beyond this
          time frame, we regret that we are unable to wait further and cannot
          provide refunds.
        </p>
        <p>
          We advise passengers taking flights to plan their rides accordingly.
          We cannot accept responsibility for missed connections or flights. No
          refunds will be initiated for those passengers.
        </p>
      </div>

      <div class="policy">
        <h2>Luggage Policy</h2>
        <p>
          Included in the cost of a ticket, each passenger is permitted one (1)
          personal item and one (1) carry-on. You are supposed to pay for the
          second bag. All the checked-in luggage is to be paid for before making
          the travel.
        </p>
        <p>
          If you are having any doubts regarding the size of the bags or any
          other inquiries, please chat with our support team or call us before
          initiating the booking. Dimensions and the details of the bags and
          luggage are hereby provided.
        </p>
        <ul>
          <li>
            Personal Item - Examples: purse, laptop bag, briefcase, small
            backpack, tote bag.
          </li>
          <li>
            Carry On - Max size: 52 cm x 23 cm x 38 cm (21” x 9” x 15”).
            Examples: small suitcase, small duffel bag.
          </li>
          <li>
            Checked Luggage (Regular) - $10 for each checked luggage that you
            carry on the way.
            <ul>
              <li>
                Max size: 157 cm (62”) total combined dimensions (height + width
                + depth)
              </li>
              <li>
                Max weight: 23 kg (50 lbs). Examples: large suitcase, large
                duffel bag.
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="policy">
        <h2>Parcel Policy</h2>
        <p>
          We provide parcel transportation to the drop-off locations or any
          locations that are closer to the 401 highway. The fare can vary upon
          our sole discretion and price changes will be reflected on the site.
        </p>
        <ul>
          <li>Envelope - $10</li>
          <li>
            Parcel boxes:
            <ul>
              <li>Size of a shoe box - $15</li>
              <li>Size of a cabin bag - $20</li>
              <li>Size of a check-in baggage - $35</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="policy">
        <h2>Dangerous Goods Policy</h2>
        <p>
          As stipulated in the Explosives Act, the following categories of
          hazardous materials are recognized:
        </p>
        <ul>
          <li>
            Gases: Compressed, refrigerated, or dissolved under pressure (e.g.,
            propane, nitrogen, sulfur dioxide).
          </li>
          <li>
            Flammable Liquids & Solids: Those with flash points below 60°C
            (e.g., gasoline, ethanol, naphthalene).
          </li>
          <li>
            Oxidizing Substances and Organic Peroxides: Compounds that promote
            combustion (e.g., ammonium nitrate, dibenzoyl peroxide).
          </li>
          <li>
            Toxic and Infectious Substances: Materials toxic through inhalation,
            skin contact, or ingestion (e.g., phenol, rabies virus).
          </li>
          <li>
            Radioactive Materials: Nuclear substances regulated by law (e.g.,
            materials in nuclear fuel rods).
          </li>
          <li>
            Corrosives: Substances causing skin damage or metal corrosion (e.g.,
            sulfuric acid, sodium hydroxide).
          </li>
          <li>
            Miscellaneous Products, Substances, or Organisms: Hazardous items
            identified for their potential risks (e.g., marine pollutants, dry
            ice, lithium batteries).
          </li>
        </ul>
      </div>

      <div class="policy">
        <h2>Drug & Alcohol Policy</h2>
        <p>
          The use of illicit and regulated substances, including alcohol, is
          strictly prohibited while traveling in our cars, except for
          medications prescribed in the passenger's own name. If a passenger is
          found to be in possession of any illegal or regulated substance, the
          driver will notify the appropriate authorities for further action at
          their discretion. The term "consumption" encompasses various methods,
          such as smoking or vaping (tobacco, marijuana, or any other
          substance), consuming beverages or food items infused with THC or
          other psychoactive substances (e.g., "edibles"), and injection.
        </p>
      </div>

      <div class="policy">
        <h2>Emergency Policy</h2>
        <p>
          In an emergency scenario, our drivers are trained to act within their
          capacities and prioritize safety. While they will make every effort to
          assist, neither our drivers nor HeyRides Inc, its affiliates,
          partners, or service providers can be held accountable for any loss or
          harm, unless in cases of gross negligence. If a situation exceeds
          their capabilities, drivers must contact emergency services and inform
          management. They may evacuate passengers if necessary, focusing on
          safety. If a driver is unable to act, HeyRides Inc. will strive to
          respond promptly, possibly by alerting emergency services or arranging
          alternative transport. In the absence of awareness, HeyRides Inc.
          cannot be held liable, relying on passengers or witnesses to report
          the situation for appropriate action.
        </p>
      </div>

      <div class="policy">
        <h2>Lost and Found Policy</h2>
        <p>
          We strive to assist passengers with their personal belongings after
          all, we won’t be responsible for any missing items. In the event of a
          lost item reported to us, we will request a description. If it
          matches, we will arrange for retrieval at a designated location. Items
          found will be held for 2-5 business days; if unclaimed, they will be
          disposed of.
        </p>
      </div>

      <div class="policy">
        <h2>WiFi Policy</h2>
        <p>
          As of now, the van does not come equipped with WiFi. However, in cases
          of emergency or upon passenger request, the driver may provide WiFi at
          their own discretion. The management bears no responsibility for any
          resulting issues.
        </p>
      </div>
    </div>
  );
}
